<div class="tw-flex tw-items-center tw-gap-2 tw-h-10 tw-select-none tw-w-full tw-justify-between">
  <span class="tw-text-sm tw-font-medium tw-text-dt-text-headings"> {{ headerName }} </span>

  <!-- Your checkbox -->
  <app-checkbox
    [title]="''"
    [checked]="isMasked()"
    [disabled]="disabled"
    [background]="'primary'"
    (onChange)="onToggle()"
  ></app-checkbox>
</div>
